jQuery(document).ready(function ($) {
  var window_size = jQuery(window).width();

  // Banner Slider JS Start
  jQuery(".banner_slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: false,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 10000,
    fade: true,
    cssEase: "linear",
  });
  // Banner Slider JS End

  // Plan Options JS Start
  initializePlanOptionsJS();
  // Plan Options JS End

  // Search product grid start
  equalizeUlHeights(jQuery(".search_products"));
  // Search product grid end

  // Most Popular Plans Slider JS Start
  jQuery(".most_popular_plans_slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    rows: 0,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  equalizeUlHeights(jQuery(".most_popular_plans_slider"));
  // Most Popular Plans Slider JS End

  // Awards Winning Slider JS Start
  jQuery(".award_winning_slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    rows: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  // Awards Winning Slider JS End

  // Testimonial Slider JS Start
  jQuery(".testimonial_slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    rows: 0,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  // Testimonial Slider JS End

  // Blog Slider JS Start
  jQuery(".blog_post_slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    rows: 0,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  // Blog Slider JS End

  // Mobile Header JS
  $(".header_toggle_btn").click(function () {
    $(".site_header").toggleClass("toggle_header");
    $("html").toggleClass("fixed");
  });

  // Mobile Header JS End

  // Sticky Header JS
  $(window).scroll(function () {
    // this will work when your window scrolled.
    var triggerHeight = $("header").outerHeight();
    var scrollTop = $(window).scrollTop();
    if (scrollTop > triggerHeight) {
      $(".sticky_header").addClass("active");
    } else {
      $(".sticky_header").removeClass("active");
    }
  });
  // Sticky Header JS End

  // Accordion JS
  // Initially hide all faq_content
  jQuery(".accordion .faq_content").hide();
  
  // Only show first if not excluded
  jQuery(".accordion").not(".no-default-open").each(function () {
    jQuery(this).find(">.accordion_items").removeClass("active_faq");
    jQuery(this).find(">.accordion_items:first").addClass("active_faq");
    jQuery(this).find(">.accordion_items:first .faq_content").slideDown();
  });
  
  // For mobile, collapse all in contact accordion
  if (window_size <= 575) {
    jQuery(".contact_accordion > .accordion_items").removeClass("active_faq");
    jQuery(".contact_accordion > .accordion_items .faq_content").slideUp();
  }


  // On click
  jQuery(".accordion_trigger").click(function (e) {
    e.preventDefault();

    var currentItem = jQuery(this).closest(".accordion_items");
    var dropDown = currentItem.find(".faq_content");

    if (currentItem.hasClass("active_faq")) {
      currentItem.removeClass("active_faq");
      dropDown.slideUp();
    } else {
      // Close others
      jQuery(".accordion .accordion_items").removeClass("active_faq");
      jQuery(".accordion .faq_content").slideUp();

      // Open current
      currentItem.addClass("active_faq");
      dropDown.slideDown({
        complete: function () {
          // Scroll to current item after open animation completes
          jQuery("html, body").animate(
            {
              scrollTop: currentItem.offset().top - 110, // adjust offset if needed
            },
            400
          );
        },
      });
    }
  });
  // // Accordion JS End
  // let faqPreloadPromise;

  // // Faqs tabbing + slider
  // jQuery(function ($) {
  //   const $tabs = $(".faq_category_box");
  //   const $faqBlocks = $(".faq_articles_block");
  //   const $searchForm = $("#faqSearchForm");
  //   const $searchInput = $("#faqSearchBar");
  //   const $searchResults = $(".faq_search_results");
  //   const $searchBlock = $("#faqSearchResults");
  //   const $faqHeading = $("#faqHeading");
  //   const $faqSlider = $(".faq_category_slider");

  //   const collapseAllFaqs = () => $(".faq_content").hide();
  //   let isInitialLoad = true;
  //   function showTabByHandle(handle) {
  //     $tabs.removeClass("active").filter(`[data-blog='${handle}']`).addClass("active");

  //     $faqBlocks.each(function () {
  //       const $block = $(this);
  //       const match = $block.data("blog") === handle;
  //       $block.toggleClass("is-hidden-tab", !match).closest(".faq_tab_content_box").toggleClass("is-hidden-tab", !match);

  //       if (match) {
  //         collapseAllFaqs();
  //         const $firstItem = $block.find(".accordion_items").first();
  //         $firstItem.addClass("active_faq");
  //         $firstItem.find(".faq_content").show();
  //         $block.hide().outerHeight(); // Reflow
  //         $block.show();
  //         if (handle !== $tabs.first().data("blog")) {
  //           scrollToElement(jQuery('.faq-categories_wp')[0]);
  //         }else if (handle == $tabs.first().data("blog") && isInitialLoad == false ){
  //           scrollToElement(jQuery('.faq-categories_wp')[0]);
  //         }
  //       }
  //     });
  //     if (isInitialLoad == true) {
  //       isInitialLoad = false;
  //     }
  //     $searchBlock.hide();
  //     $searchResults.empty();
  //     $searchInput.val("");
  //     $faqHeading.show();
  //   }
    
  //   const faqPageCache = {};
  //   faqPreloadPromise = Promise.all(
  //     $tabs.map(function () {
  //       const handle = $(this).data("blog");
    
  //       if (faqPageCache[handle]) return Promise.resolve(); // Already cached
    
  //       const allItems = [];
  //       let page = 1;
    
  //       const fetchPages = async () => {
  //         while (true) {
  //           try {
  //             const res = await fetch(`/blogs/${handle}?page=${page}`);
  //             const html = await res.text();
  //             const $temp = $("<div>").html(html);
  //             const items = $temp.find(".accordion_items");
    
  //             if (!items.length) break;
  //             allItems.push(...items);
  //             page++;
  //           } catch {
  //             break;
  //           }
  //         }
  //         faqPageCache[handle] = allItems;
  //       };
    
  //       return fetchPages();
  //     }).get()
  //   );

  //   // async function handleSearch(keyword) {
  //   //   await faqPreloadPromise;
    
  //   //   const term = keyword.trim().toLowerCase();
  //   //   $searchResults.empty();
  //   //   $tabs.removeClass("active");
  //   //   $faqBlocks.addClass("is-hidden-tab");
  //   //   $(".faq_tab_content_box .h3-title").hide();
    
  //   //   if (!term) return showTabByHandle($tabs.first().data("blog"));
    
  //   //   $searchBlock.show().removeClass("is-hidden-tab").closest(".faq_tab_content_box").removeClass("is-hidden-tab");
  //   //   const added = new Set();
  //   //   let match = 0;
  //   //   let firstMatchShown = false;
    
  //   //   const displayResult = ($el) => {
  //   //     const title = $el.find(".h4_title").text().toLowerCase();
  //   //     const body = $el.find(".faq_content").text().toLowerCase();
  //   //     const combinedText = title + " " + body;
  //   //     if (combinedText.includes(term) && !added.has(title)){
  //   //       const $clone = $el.clone();
  //   //       $clone.removeClass("active_faq").find(".faq_content").hide();
    
  //   //       if (!firstMatchShown) {
  //   //         $clone.addClass("active_faq");
  //   //         $clone.find(".faq_content").css("display", "block");
  //   //         $searchResults.append($clone);
  //   //         setTimeout(() => {
  //   //           $("html, body").animate({ scrollTop: $clone.offset().top - 180 }, 300);
  //   //         }, 10);
  //   //         firstMatchShown = true;
  //   //       } else {
  //   //         $searchResults.append($clone);
  //   //       }
    
  //   //       added.add(title);
  //   //       match++;
  //   //     }
  //   //   };
    
  //   //   const fetchAllPages = async (handle) => {
  //   //     if (faqPageCache[handle]) return faqPageCache[handle];
    
  //   //     const allItems = [];
  //   //     let page = 1;
    
  //   //     while (true) {
  //   //       try {
  //   //         const res = await fetch(`/blogs/${handle}?page=${page}`);
  //   //         const html = await res.text();
  //   //         const $temp = $("<div>").html(html);
  //   //         const items = $temp.find(".accordion_items");
    
  //   //         if (!items.length) break;
  //   //         allItems.push(...items);
  //   //         page++;
  //   //       } catch {
  //   //         break;
  //   //       }
  //   //     }
    
  //   //     faqPageCache[handle] = allItems; // Cache for next time
  //   //     return allItems;
  //   //   };
    
  //   //   const handles = $tabs.map(function () {
  //   //     return $(this).data("blog");
  //   //   }).get();
    
  //   //   handles.forEach(async (handle) => {
  //   //     const items = await fetchAllPages(handle);
  //   //     items.forEach((item) => {
  //   //       const $el = $(item);
  //   //       displayResult($el);
  //   //     });
    
  //   //     if (handle === handles.at(-1)) {
  //   //       const cap = term.charAt(0).toUpperCase() + term.slice(1);
  //   //       $searchBlock.find(".h3-title").text(`FAQs for “${cap}”`).show();
  //   //       if (!match) $searchResults.html("<p>No results found.</p>");
    
  //   //       // Rebind click events
  //   //       $searchResults.find(".accordion_trigger").off("click").on("click", function () {
  //   //         const $item = $(this).closest(".accordion_items");
  //   //         const $content = $item.find(".faq_content");
  //   //         const isActive = $item.hasClass("active_faq");
    
  //   //         $searchResults.find(".accordion_items").removeClass("active_faq").find(".faq_content").slideUp();
  //   //         if (!isActive) {
  //   //           $item.addClass("active_faq");
  //   //           $content.slideDown();
  //   //         }
  //   //       });
  //   //     }
  //   //   });
  //   // }
    
  //   function initialize_faqs($faqSlider) {
  //     const handleFromURL = window.location.pathname.includes("/blogs/")? window.location.pathname.split("/blogs/")[1].split("/")[0]: null;
  //     const $targetTab = $tabs.filter(`[data-blog='${handleFromURL}']`);
  //     localStorage.removeItem("faq_active_index");
  //     if (window.innerWidth >= 576) {
  //       if( $faqSlider.length && !$faqSlider.hasClass("slick-initialized") ){
  //         $faqSlider.slick({
  //           infinite: true,
  //           slidesToShow: 4,
  //           slidesToScroll: 1,
  //           speed: 1000,
  //           dots: true,
  //           arrows: true,
  //           prevArrow:
  //             '<button type="button" class="slick-arrow slick-prev plan_options_prev"></button>',
  //           nextArrow:
  //             '<button type="button" class="slick-arrow slick-next plan_options_next"></button>',
  //           rows: 0,
  //           autoplay: false,
  //           responsive: [
  //             { breakpoint: 1400, settings: { slidesToShow: 3 } },
  //             { breakpoint: 992, settings: { slidesToShow: 2 } },
  //             { breakpoint: 768, settings: { slidesToShow: 1 } },
  //           ],
  //         });
  
  //         // Update active tab when slide changes
  //         $faqSlider.on("afterChange", function (event, slick, currentSlide) {
  //           // const $current = $(slick.$slides.get(currentSlide));
  //           // const $categoryBox = $current.find(".faq_category_box");
  //           // const handle = $categoryBox.data("blog");
    
  //           // if (handle) {
  //           //   $(".faq_category_slider .slick-slide").removeClass("active");
  //           //   $current.addClass("active");
  //           //   showTabByHandle(handle); // Show correct content
  //           //   // Do NOT update URL
  //           // }
  //         });
  //       }
  //       if ($targetTab.length) {
  //         const index = $tabs.index($targetTab);
  //         setTimeout(() => {
  //           if ($faqSlider.hasClass("slick-initialized")) {
  //             $faqSlider.slick("slickGoTo", index);
  //             $faqSlider.find(".slick-slide").removeClass("active").eq(index).addClass("active");
  //             if( !jQuery('[data-blog="'+handleFromURL+'"]').hasClass('active') ){
  //               jQuery('[data-blog="'+handleFromURL+'"]').addClass("active");
  //               showTabByHandle(handleFromURL);
  //             }
  //           }
  //         }, 100);
  //       } else {
  //         setTimeout(() => {
  //           if ($faqSlider.hasClass("slick-initialized")) {
  //             $faqSlider.slick("slickGoTo", 0);
  //             $faqSlider.find(".slick-slide").removeClass("active").eq(0).addClass("active");
  //             var firstHandle = $tabs.first().data("blog");
  //             if( !jQuery('[data-blog="'+firstHandle+'"]').hasClass('active') ){
  //               jQuery('[data-blog="'+firstHandle+'"]').addClass("active");
  //               showTabByHandle(firstHandle);
  //             }
  //           }
  //         }, 100);
  //       }
  //     }else{
  //       if ($faqSlider.hasClass("slick-initialized")) {
  //         $faqSlider.slick("unslick");
  //       }
  //       if ($targetTab.length) {
  //         $targetTab.addClass('active');
  //         showTabByHandle($targetTab.data("blog"));
  //         scrollToElement(jQuery('.main_faq_content')[0]);
  //       }else{
  //         $tabs.eq(0).addClass('active');
  //         showTabByHandle($tabs.eq(0).data("blog"));
  //       }
  //     }
  //   }

  //   // Init Slick
  //   let faqResizeTimeout;
  //   let currentFaqWindowWidth = window.innerWidth;
  //   initialize_faqs($faqSlider);
  //   $(window).on("resize", function () {
  //     clearTimeout(faqResizeTimeout);
  //     faqResizeTimeout = setTimeout(function () {
  //       const newFaqWindowWidth = window.innerWidth;
  //       // Re-initialize only if crossing the 576px breakpoint
  //       if (
  //         (currentFaqWindowWidth < 576 && newFaqWindowWidth >= 576) ||
  //         (currentFaqWindowWidth >= 576 && newFaqWindowWidth < 576)
  //       ) {
  //         initialize_faqs($faqSlider);
  //       }
  //       currentFaqWindowWidth = newFaqWindowWidth;
  //       equalizeUlHeights(jQuery(".most_popular_plans_slider"));
  //     }, 300);
  //   });
  //   // Tab click handler (manual switch)
  //   $(document).on("click", ".faq_category_slider .faq_category_box", function () {
  //     const $clicked = $(this);
  //     const handle = $clicked.data("blog");
  //     const index = $clicked.closest(".slick-slide").data("slick-index");

  //     if (handle) {
  //       localStorage.setItem("faq_active_index", index);
  //       $(".faq_category_slider .slick-slide").removeClass("active");
  //       $clicked.closest(".slick-slide").addClass("active");
  //       // Redirect to clean URL only
  //       window.location.href = `/blogs/${handle}`;
  //     }
  //   }
  //   );

  //   // --- Search ---
  //   // $searchForm.on("submit", function (e) {
  //   //   e.preventDefault();
  //   //   handleSearch($searchInput.val());
  //   // });

  //   // $searchInput.on("input", function () {
  //   //   if (!$(this).val().trim()) {
  //   //     location.reload();
  //   //   }
  //   // });
  // });
  // // FAQ Categories Slider JS End

  // Awards Tabbing JS Start
  jQuery(".custom_awards_tab ul li").on("click", function () {
    const selectedTab = jQuery(this).data("tab");

    // Handle active class
    jQuery(".custom_awards_tab ul li").removeClass("active");
    jQuery(this).addClass("active");

    // Filter content
    if (selectedTab === "all") {
      jQuery(".award_card").show();
    } else {
      jQuery(".award_card").hide();
      jQuery(`.award_card[data-category="${selectedTab}"]`).show();
    }
  });
  // Awards Tabbing JS End

  // Feature Blog Slider JS Start
  jQuery(".custom_blog_slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    rows: 0,
    autoplay: false,
    autoplaySpeed: 3000,
  });
  // Feature Blog Slider JS End

  // Share Article JS Start
  jQuery("#shareArticle").on("click", function (e) {
    e.preventDefault();

    // Copy current page URL to clipboard
    const pageUrl = window.location.href;
    navigator.clipboard.writeText(pageUrl).then(function () {
      // Show tooltip
      jQuery(".share_article_tooltip").stop(true, true).fadeIn(200);

      // Automatically fade out after 3 seconds
      setTimeout(function () {
        jQuery(".share_article_tooltip").fadeOut(300);
      }, 1800);
    });
  });
  // Share Article JS End
});

// award winning tabbing filter start
$(document).ready(function () {
  const isMobile = window.innerWidth < 992;

  // Sort blocks by year descending
  let $cards = $(".award_card");
  $cards.sort(function (a, b) {
    return parseInt($(b).data("year")) - parseInt($(a).data("year"));
  });
  $(".custom_awards_tab_content .row").first().html($cards); // replace container content

  // Now same logic as before...
  if ($(".custom_awards_tab ul li.active").data("tab") === "all") {
    $(".award_card").each(function (index) {
      if (index < 8) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }

  $(".custom_awards_tab ul li").on("click", function () {
    const selectedTab = $(this).data("tab");

    $(".custom_awards_tab ul li").removeClass("active");
    $(this).addClass("active");

    if (selectedTab === "all") {
      $(".award_card").each(function (index) {
        if (index < 8) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    } else {
      let shownCount = 0;
      $(".award_card").each(function () {
        var $card = $(this);
        if ($card.data("category") === selectedTab) {
          if (shownCount < 8) {
            $card.show();
            shownCount++;
          } else {
            $card.hide();
          }
        } else {
          $card.hide();
        }
      });
    }
  });
});

// award winning tabbing filter end


// Alert popup close
$(document).ready(function () {
  $('.cart_limit_alert_close').on('click', function () {
    $(this).closest('.limit_alert_wrapper').hide();
  });
});
// alert popup close end

function scrollToElement(element) {
  const offset = 100;
  const top = element.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: "smooth" });
}

// Scroll down of service status page button
 jQuery(document).ready(function () {
    jQuery('.scroll-button').on('click', function (e) {
      var targetSelector = jQuery(this).attr('href');

      if (targetSelector && targetSelector.startsWith('#')) {
        e.preventDefault();

        var target = jQuery(targetSelector);
        if (target.length) {
          var headerOffset = 80; // adjust this value to your header height
          var targetPosition = target.offset().top - headerOffset;

          jQuery('html, body').animate({
            scrollTop: targetPosition
          }, 600);
        }
      }
    });
  });

// start FAQs triggering URL change
jQuery(".main_faq_content .h4_title.accordion_trigger").click(function(e) {
  e.preventDefault();
  const articleUrl = $(this).data('article-url');
  
  // Update URL without reload
  window.history.replaceState({}, document.title, articleUrl);
  
  // Optional: Update page title
  document.title = `${$(this).text()} | ${document.title.split('|')[1]}`;
});
// end FAQs triggering URL change

jQuery(document).ready(function () {
  // Start eSIM show list triggering
  document.querySelector('a[href="#hide_list"]').addEventListener("click", function(event) {
    event.preventDefault();
    this.classList.add("show");
  });
  // End eSIM show list triggering

  function debounce(fn, wait = 150) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function countLists() {
    let width = window.innerWidth;
    if (width <= 767) {
      const lists = document.querySelectorAll('.main_product_details .rte ul, .main_product_details .rte ol');

      if (lists.length === 0) {
        return;
      }

      lists.forEach((list, idx) => {
        const liItems = list.querySelectorAll(":scope > li"); // direct children only
        const liCount = liItems.length;
        if (liCount > 4) {
          if (list.dataset.expanded === "true" || (list.nextElementSibling && list.nextElementSibling.classList.contains("view-more-btn"))) {
            return;
          }

          // Hide items after the 3rd one
          liItems.forEach((li, i) => {
            if (i >= 4) li.style.display = "none";
          });

          // Create button
          const btn = document.createElement("button");
          btn.textContent = "View more";
          btn.className = "view-more-btn";
          btn.setAttribute("data-expanded", "false");

          // Insert button after the list
          list.insertAdjacentElement("afterend", btn);

          // Expand once on click
          btn.addEventListener("click", function() {
            liItems.forEach(li => li.style.display = "");
            btn.remove(); // remove button after expanding
            list.dataset.expanded = "true";
          });
        }
      });
    }
  }

  // Start PDP Hide/Show description list
  if (window.location.pathname.includes("/products/")) {
    countLists();
    window.addEventListener("resize", debounce(countLists, 150));    
  };
  // End PDP Hide/Show description list
});